import React, { useEffect, useState, useCallback } from "react";

import {
  Switch,
  Route,
  useLocation,
  useHistory,
  Redirect,
} from "react-router-dom";
import Home from "../../pages/Home";
import Login from "../../pages/Login";
import Layout from "../Layout";
import { checkEntity } from "./PageData/data";
import NotFound from "../../pages/NotFound";
import { Flex } from "@chakra-ui/react";

import ServicosAcolhimento from "../../pages/ServicosAcolhimento";
import ServicoAcolhimentoCadastrar from "../../pages/ServicosAcolhimento/Cadastrar";
import VisualizarServicoAtendimento from "../../pages/ServicosAcolhimento/Visualizar";
import ServicoAcolhimentoEditar from "../../pages/ServicosAcolhimento/Editar";

import PanelBase from "../../pages/ServicosAcolhimento/PanelBase";

import PerfilServicoAcolhimento from "../../pages/ServicosAcolhimento/Perfil";
import CadastrarPerfil from "../../pages/ServicosAcolhimento/Perfil/Cadastrar";
import EditarPerfil from "../../pages/ServicosAcolhimento/Perfil/Editar";

import CadastrarGestao from "../../pages/ServicosAcolhimento/Gestao/Cadastrar";
import GestaoServicoAcolhimento from "../../pages/ServicosAcolhimento/Gestao";
import EditarGestao from "../../pages/ServicosAcolhimento/Gestao/Editar";

import CadastrarPlanejamento from "../../pages/ServicosAcolhimento/Planejamento/Cadastrar";
import PlanejamentoServicoAcolhimento from "../../pages/ServicosAcolhimento/Planejamento";
import EditarPlanejamento from "../../pages/ServicosAcolhimento/Planejamento/Editar";

import CadastrarRedeReferencia from "../../pages/ServicosAcolhimento/RedeReferencia/Cadastrar";
import RedeReferenciaServicoAcolhimento from "../../pages/ServicosAcolhimento/RedeReferencia";
import EditarRedeReferencia from "../../pages/ServicosAcolhimento/RedeReferencia/Editar";

import EquipeServicoAcolhimento from "../../pages/ServicosAcolhimento/Equipe";

import VoluntariadoServicoAcolhimento from "../../pages/ServicosAcolhimento/Voluntariado";

import PessoaEmCumprimentoServicoAcolhimento from "../../pages/ServicosAcolhimento/PessoaEmCumprimento";

import FamiliaAcolhedoraServicoAcolhimento from "../../pages/ServicosAcolhimento/FamiliaAcolhedora";

import AnexosServicoAcolhimento from "../../pages/ServicosAcolhimento/Anexos";
import CadastrarAnexos from "../../pages/ServicosAcolhimento/Anexos/Cadastrar";

import RegularidadeServicoAcolhimento from "../../pages/ServicosAcolhimento/Regularidade";
import CadastrarRegularidade from "../../pages/ServicosAcolhimento/Regularidade/Cadastrar";
import EditarRegularidade from "../../pages/ServicosAcolhimento/Regularidade/Editar";

import { Criancas } from "../../pages/Criancas";
import { RelatoriosPendencias } from "../../pages/Relatorios/Pendencias";
import { FilaProcessamento } from "../../pages/FilaProcessamento";

import { CadastrarCrianca } from "../../pages/Criancas/Cadastrar";
import { VisualizarCrianca } from "../../pages/Criancas/Visualizar";
import { EditarCrianca } from "../../pages/Criancas/Editar";

import { PanelBase as PanelBaseCrianca } from "../../pages/Criancas/PanelBase";

import { CadastrarDocumentacao } from "../../pages/Criancas/Documentacao/Cadastrar";
import { EditarDocumentacao } from "../../pages/Criancas/Documentacao/Editar";
import { VisualizarDocumentacao } from "../../pages/Criancas/Documentacao";

import { VisualizarMovimentacao } from "../../pages/Criancas/Movimentacao";
import { VisualizarSaude } from "../../pages/Criancas/Saude";

import ListaMotivoSituacao from "../../pages/MotivoSituacao/Lista";
import ListaVisitas from "../../pages/Visitas/Lista";
import CadastrarVisitas from "../../pages/Visitas/Cadastrar";
import VisualizarVisitas from "../../pages/Visitas/Visualizar";
import RegistrarDoenca from "../../pages/Doenca/Registrar";
import CadastrarSituacaoJuridica from "../../pages/SituacaoJuridica/Cadastrar";
import ListaSituacaoJuridica from "../../pages/SituacaoJuridica/Lista";
import VisualizarSituacaoJuridica from "../../pages/SituacaoJuridica/Visualizar";
import EditarSituacaoJuridica from "../../pages/SituacaoJuridica/Editar";
import CadastrarMotivoSituacao from "../../pages/MotivoSituacao/Cadastrar";
import VisualizarMotivoSituacao from "../../pages/MotivoSituacao/Visualizar";
import EditarMotivoSituacao from "../../pages/MotivoSituacao/Editar";
import AlterarVigenciaMotivoSituacao from "../../pages/MotivoSituacao/AlterarVigencia";
import ListaDoenca from "../../pages/Doenca/Lista";
import VisualizarDoenca from "../../pages/Doenca/Visualizar";
import EditarDoenca from "../../pages/Doenca/Editar";
import AlterarVigenciaDoenca from "../../pages/Doenca/AlterarVigencia";
import AlterarVigenciaSituacaoJuridica from "../../pages/SituacaoJuridica/AlterarVigencia";
import ListaPerfilAcesso from "../../pages/PerfilAcesso/Lista";
import CadastrarPerfilAcesso from "../../pages/PerfilAcesso/Cadastrar";
import VisualizarPerfilAcesso from "../../pages/PerfilAcesso/Visualizar";
import EditarPerfilAcesso from "../../pages/PerfilAcesso/Editar";
import AlterarVigenciaPerfilAcesso from "../../pages/PerfilAcesso/AlterarVigencia";
import { VisualizarProfissionalizacao } from "../../pages/Criancas/Profissionalizacao";
import { VisualizarEducacao } from "../../pages/Criancas/Educacao";
import { VisualizarReferenciaFamiliar } from "../../pages/Criancas/ReferenciaFamiliar/Visualizar";
import PrivateRoute from "../../../helpers/PrivateRoute";
import { VisualizarOcorrencias } from "../../pages/Criancas/Ocorrencias";
import { VisualizarVisita } from "../../pages/Criancas/Visita/Visitas/Visualizar";
import EditarVisitas from "../../pages/Visitas/Editar";
import { MessageContextProvider } from "../../../Context/MessageContextProvider";
import { SituacoesJuridicas } from "../../pages/Criancas/SituacaoJuridica/SituacoesJuridicas/Visualizar";
import { VisualizarAnexosCrianca } from "../../pages/Criancas/Anexos";
import { VisualizarApadrinhamento } from "../../pages/Criancas/Apadrinhamento";
import { VisualizarPendencia } from "../../pages/Criancas/Pendencias";
import { VisualizarPendenciaServico } from "../../pages/ServicosAcolhimento/Pendencias";
import CadastrarApadrinhamentoServico from "../../pages/ServicosAcolhimento/Apadrinhamento/Cadastrar";
import EditarApadrinhamentoServico from "../../pages/ServicosAcolhimento/Apadrinhamento/Editar";
import VisualizarApadrinhamentoServico from "../../pages/ServicosAcolhimento/Apadrinhamento";
import DashboardServicoAcolhimento from "../../pages/Dashboard/DashboardServicoAcolhimento";
import DashboardCrianca from "../../pages/Dashboard/DashboardCrianca";
import DashboardCriancaPendencia from "../../pages/Dashboard/DashboardCriancaPendencia";
import DashboardServicoAcolhimentoPendencia from "../../pages/Dashboard/DashboardServicoAcolhimentoPendencia";
import DashboardAvisos from "../../pages/Dashboard/DashboardAvisos";
import { RelatoriosCriancaAdolescente } from "../../pages/Relatorios/CriancaAdolescente";
import { RelatoriosCriancaAdolescenteGeral } from "../../pages/Relatorios/CriancaAdolescenteGeral";
import { RelatoriosServicoAcolhimento } from "../../pages/Relatorios/ServicoAcolhimento";
import { useAuthProvider } from "../../../Context/AuthProvider";
import { dashboardFunc } from "../../../helpers/Funcionalidades";
import Auditoria from "../../pages/Auditoria";
import AuditoriaServico from "../../pages/Auditoria/Servico";
import AuditoriaCrianca from "../../pages/Auditoria/Crianca";

function Routes(props) {
  const [category, setCategory] = useState("");
  const [page, setPage] = useState("");
  const [entity, setEntity] = useState("");
  const [url, setUrl] = useState("");
  let history = useHistory();
  const urlfinal = useLocation();
  const { roleKeycloack } = useAuthProvider();
  const [loading, setLoading] = useState(false);
  const [loadingPainel, setLoadingPainel] = useState(false);
  const [dataNascimento, setDataNascimento] = useState();

  const setLayoutData = useCallback(() => {
    const urlAarry = urlfinal.pathname.split("/");
    const layoutInformation = checkEntity(urlAarry[1], urlAarry[2]);

    if (layoutInformation) {
      setCategory(layoutInformation.currentCategory);
      setPage(layoutInformation.page);
      setEntity(layoutInformation.entity);
      setUrl(layoutInformation.href);
    }
    setLoading(false);
  }, [urlfinal, setCategory, setPage, setEntity, setUrl, setLoading]);

  useEffect(() => {
    setLoading(true);
    setLayoutData();
  }, [urlfinal, setLayoutData]);

  useEffect(() => {
    setLoadingPainel(false);
  }, [loadingPainel]);

  return (
    <Flex>
      <PrivateRoute>
        <MessageContextProvider>
          <Layout
            loading={loading}
            currentCateory={category}
            entidade={entity}
            entidadeHref={url}
            pagina={page}
          >
            <Switch history={history}>
              <Route exact path="/" component={Login} />
              <Route exact path="/dashboard">
                <Home />
              </Route>

              {/* SERVIÇOS DE ACOLHIMENTO */}
              <Route
                exact
                path="/servico-acolhimento"
                component={ServicosAcolhimento}
              />
              <Route
                exact
                path="/servico-acolhimento/cadastrar"
                component={ServicoAcolhimentoCadastrar}
              />
              <Route exact path="/servico-acolhimento/editar/:id(\d+)">
                <PanelBase>
                  <ServicoAcolhimentoEditar />
                </PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/:id(\d+)">
                <PanelBase loadingPainel={loadingPainel}>
                  <VisualizarServicoAtendimento
                    setLoadingPainel={setLoadingPainel}
                  />
                </PanelBase>
              </Route>
              {/* PERFIL */}
              <Route
                exact
                path="/servico-acolhimento/cadastrar-perfil/:id(\d+)"
              >
                <PanelBase>
                  <CadastrarPerfil />
                </PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/editar-perfil/:id(\d+)">
                <PanelBase>
                  <EditarPerfil />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/visualizar-perfil/:id(\d+)"
              >
                <PanelBase>
                  <PerfilServicoAcolhimento />
                </PanelBase>
              </Route>
              {/* GESTÃO */}
              <Route
                exact
                path="/servico-acolhimento/cadastrar-gestao/:id(\d+)"
              >
                <PanelBase>
                  <CadastrarGestao />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/visualizar-gestao/:id(\d+)"
              >
                <PanelBase>
                  <GestaoServicoAcolhimento />
                </PanelBase>
              </Route>
              <Route exact path="/servico-acolhimento/editar-gestao/:id(\d+)">
                <PanelBase>
                  <EditarGestao />
                </PanelBase>
              </Route>
              {/* PLANEJAMENTO */}
              <Route
                exact
                path="/servico-acolhimento/cadastrar-planejamento/:id(\d+)"
              >
                <PanelBase>
                  <CadastrarPlanejamento />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/visualizar-planejamento/:id(\d+)"
              >
                <PanelBase>
                  <PlanejamentoServicoAcolhimento />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/editar-planejamento/:id(\d+)"
              >
                <PanelBase>
                  <EditarPlanejamento />
                </PanelBase>
              </Route>
              {/* REDE DE REFERÊNCIA */}
              <Route
                exact
                path="/servico-acolhimento/cadastrar-rede-de-referencia/:id(\d+)"
              >
                <PanelBase>
                  <CadastrarRedeReferencia />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/visualizar-rede-de-referencia/:id(\d+)"
              >
                <PanelBase>
                  <RedeReferenciaServicoAcolhimento />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/editar-rede-de-referencia/:id(\d+)"
              >
                <PanelBase>
                  <EditarRedeReferencia />
                </PanelBase>
              </Route>
              {/* APADRINHAMENTO */}
              <Route
                exact
                path="/servico-acolhimento/cadastrar-apadrinhamento/:id(\d+)"
              >
                <PanelBase>
                  <CadastrarApadrinhamentoServico />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/visualizar-apadrinhamento/:id(\d+)"
              >
                <PanelBase>
                  <VisualizarApadrinhamentoServico />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/editar-apadrinhamento/:id(\d+)"
              >
                <PanelBase>
                  <EditarApadrinhamentoServico />
                </PanelBase>
              </Route>
              {/* REGULARIDADE */}
              <Route
                exact
                path="/servico-acolhimento/cadastrar-regularidade/:id(\d+)"
              >
                <PanelBase>
                  <CadastrarRegularidade />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/editar-regularidade/:id(\d+)"
              >
                <PanelBase>
                  <EditarRegularidade />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/visualizar-regularidade/:id(\d+)"
              >
                <PanelBase>
                  <RegularidadeServicoAcolhimento />
                </PanelBase>
              </Route>
              {/* EQUIPE */}
              <Route
                exact
                path="/servico-acolhimento/visualizar-equipe/:id(\d+)"
              >
                <PanelBase loadingPainel={loadingPainel}>
                  <EquipeServicoAcolhimento
                    setLoadingPainel={setLoadingPainel}
                  />
                </PanelBase>
              </Route>
              {/* VOLUNTARIADO */}
              <Route
                exact
                path="/servico-acolhimento/visualizar-voluntariado/:id(\d+)"
              >
                <PanelBase>
                  <VoluntariadoServicoAcolhimento />
                </PanelBase>
              </Route>
              {/* PESSOA EM CUMPRIMENTO DE PENA */}
              <Route
                exact
                path="/servico-acolhimento/visualizar-pessoa-em-cumprimento-de-pena/:id(\d+)"
              >
                <PanelBase>
                  <PessoaEmCumprimentoServicoAcolhimento />
                </PanelBase>
              </Route>
              {/* FAMILIA ACOLHEDORA */}
              <Route
                exact
                path="/servico-acolhimento/visualizar-familia-acolhedora/:id(\d+)"
              >
                <PanelBase>
                  <FamiliaAcolhedoraServicoAcolhimento />
                </PanelBase>
              </Route>
              {/* ANEXOS */}
              <Route
                exact
                path="/servico-acolhimento/visualizar-anexos/:id(\d+)"
              >
                <PanelBase>
                  <AnexosServicoAcolhimento />
                </PanelBase>
              </Route>
              <Route
                exact
                path="/servico-acolhimento/cadastrar-anexos/:id(\d+)/categoria/:idCategoria"
              >
                <PanelBase>
                  <CadastrarAnexos />
                </PanelBase>
              </Route>

              {/* CRIANÇA */}
              <Route exact path="/crianca" component={Criancas} />
              <Route
                exact
                path="/crianca/cadastrar"
                component={CadastrarCrianca}
              />
              <Route exact path="/crianca/editar/:id(\d+)">
                <PanelBaseCrianca>
                  <EditarCrianca />
                </PanelBaseCrianca>
              </Route>
              <Route exact path="/crianca/:id(\d+)">
                <PanelBaseCrianca
                  loadingPainel={loadingPainel}
                  setLoadingPainel={setLoadingPainel}
                >
                  <VisualizarCrianca setLoadingPainel={setLoadingPainel} />
                </PanelBaseCrianca>
              </Route>

              {/* DOCUMENTACAO */}
              <Route exact path="/crianca/cadastrar-documentacao/:id(\d+)">
                <PanelBaseCrianca setDataNascimento={setDataNascimento}>
                  <CadastrarDocumentacao dataNascimento={dataNascimento} />
                </PanelBaseCrianca>
              </Route>
              <Route exact path="/crianca/editar-documentacao/:id(\d+)">
                <PanelBaseCrianca setDataNascimento={setDataNascimento}>
                  <EditarDocumentacao dataNascimento={dataNascimento} />
                </PanelBaseCrianca>
              </Route>
              <Route exact path="/crianca/visualizar-documentacao/:id(\d+)">
                <PanelBaseCrianca setDataNascimento={setDataNascimento}>
                  <VisualizarDocumentacao dataNascimento={dataNascimento} />
                </PanelBaseCrianca>
              </Route>

              {/* MOVIMENTACAO */}
              <Route exact path="/crianca/visualizar-movimentacao/:id(\d+)">
                <PanelBaseCrianca
                  loadingPainel={loadingPainel}
                  setDataNascimento={setDataNascimento}
                >
                  <VisualizarMovimentacao
                    setLoadingPainel={setLoadingPainel}
                    dataNascimento={dataNascimento}
                  />
                </PanelBaseCrianca>
              </Route>

              {/* SAÚDE */}
              <Route exact path="/crianca/visualizar-saude/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarSaude />
                </PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-saude/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarSaude />
                </PanelBaseCrianca>
              </Route>

              {/*APADRINHAMENTO */}
              <Route exact path="/crianca/visualizar-apadrinhamento/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarApadrinhamento />
                </PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-apadrinhamento/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarApadrinhamento />
                </PanelBaseCrianca>
              </Route>

              {/* PROFISSIONALIZAÇÃO */}
              <Route
                exact
                path="/crianca/visualizar-profissionalizacao/:id(\d+)"
              >
                <PanelBaseCrianca>
                  <VisualizarProfissionalizacao />
                </PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-profissionalizacao/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarProfissionalizacao />
                </PanelBaseCrianca>
              </Route>

              {/* REFERÊNCIA FAMILIAR */}
              <Route
                exact
                path="/crianca/visualizar-referencia-familiar/:id(\d+)"
              >
                <PanelBaseCrianca loadingPainel={loadingPainel}>
                  <VisualizarReferenciaFamiliar
                    setLoadingPainel={setLoadingPainel}
                  />
                </PanelBaseCrianca>
              </Route>

              {/* CRIANCA-VISITAS */}
              <Route exact path="/crianca/visualizar-visitas/:id(\d+)">
                <PanelBaseCrianca loadingPainel={loadingPainel}>
                  <VisualizarVisita setLoadingPainel={setLoadingPainel} />
                </PanelBaseCrianca>
              </Route>

              {/* Ocorrências */}
              <Route exact path="/crianca/visualizar-ocorrencias/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarOcorrencias />
                </PanelBaseCrianca>
              </Route>

              <Route
                exact
                path="/crianca/editar-ocorrencias/:id(\d+)/:idOrgaoExterno"
              >
                <PanelBaseCrianca>
                  <VisualizarOcorrencias />
                </PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/cadastrar-ocorrencias/:id(\d+)">
                <PanelBaseCrianca
                  loadingPainel={loadingPainel}
                  setLoadingPainel={setLoadingPainel}
                >
                  <VisualizarOcorrencias setLoadingPainel={setLoadingPainel} />
                </PanelBaseCrianca>
              </Route>

              {/* EDUCAÇÃO */}
              <Route exact path="/crianca/visualizar-educacao/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarEducacao />
                </PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-educacao/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarEducacao />
                </PanelBaseCrianca>
              </Route>

              {/*SITUACAO JURIDICA CRIANÇA*/}
              <Route
                exact
                path="/crianca/visualizar-situacao-juridica/:id(\d+)"
              >
                <PanelBaseCrianca
                  loadingPainel={loadingPainel}
                  setLoadingPainel={setLoadingPainel}
                >
                  <SituacoesJuridicas setLoadingPainel={setLoadingPainel} />
                </PanelBaseCrianca>
              </Route>

              {/* ANEXOS CRIANÇA */}
              <Route exact path="/crianca/visualizar-anexos/:id(\d+)">
                <PanelBaseCrianca
                  setDataNascimento={setDataNascimento}
                  loadingPainel={loadingPainel}
                  setLoadingPainel={setLoadingPainel}
                >
                  <VisualizarAnexosCrianca
                    dataNascimento={dataNascimento}
                    setLoadingPainel={setLoadingPainel}
                  />
                </PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/editar-anexos/:id(\d+)/:idAnexo">
                <PanelBaseCrianca>
                  <VisualizarAnexosCrianca />
                </PanelBaseCrianca>
              </Route>

              <Route exact path="/crianca/cadastrar-anexos/:id(\d+)">
                <PanelBaseCrianca
                  loadingPainel={loadingPainel}
                  setLoadingPainel={setLoadingPainel}
                  setDataNascimento={setDataNascimento}
                >
                  <VisualizarAnexosCrianca
                    dataNascimento={dataNascimento}
                    setLoadingPainel={setLoadingPainel}
                  />
                </PanelBaseCrianca>
              </Route>

              {/* PENDÊNCIAS */}
              <Route exact path="/crianca/visualizar-pendencias/:id(\d+)">
                <PanelBaseCrianca>
                  <VisualizarPendencia />
                </PanelBaseCrianca>
              </Route>

              <Route
                exact
                path="/servico-acolhimento/visualizar-pendencias/:id(\d+)"
              >
                <PanelBase>
                  <VisualizarPendenciaServico />
                </PanelBase>
              </Route>

              {/* TIPO SERVIÇO ACOLHIMENTO */}

              {/* <Route exact path="/tipo-servico-acolhimento/cadastrar" component={RegistrarTipoServicoAcolhimento} /> */}
              {/* <Route exact path="/tipo-servico-acolhimento/lista" loading={loading} component={ListaTipoServicoAcolhimento} /> */}
              {/* <Route exact path="/tipo-servico-acolhimento/:id(\d+)" component={VisualizarTipoServicoAcolhimento} />
              <Route exact path="/tipo-servico-acolhimento/editar/:id(\d+)" component={EditarTipoServicoAcolhimento} />
              <Route exact path="/tipo-servico-acolhimento/alterar-vigencia/:id(\d+)" component={AlterarVigenciaTipoServicoAcolhimento} /> */}

              {/*SITUACAO JURIDICA*/}
              <Route
                exact
                path="/situacao-juridica/cadastrar"
                component={CadastrarSituacaoJuridica}
              />
              <Route
                exact
                path="/situacao-juridica/lista"
                component={ListaSituacaoJuridica}
              />
              <Route
                exact
                path="/situacao-juridica/:id(\d+)"
                component={VisualizarSituacaoJuridica}
              />
              <Route
                exact
                path="/situacao-juridica/editar/:id(\d+)"
                component={EditarSituacaoJuridica}
              />
              <Route
                exact
                path="/situacao-juridica/alterar-vigencia/:id(\d+)"
                component={AlterarVigenciaSituacaoJuridica}
              />

              {/*MOTIVO SITUACAO*/}
              <Route
                exact
                path="/motivo-situacao/cadastrar"
                component={CadastrarMotivoSituacao}
              />
              <Route
                exact
                path="/motivo-situacao/lista"
                component={ListaMotivoSituacao}
              />
              <Route
                exact
                path="/motivo-situacao/:id(\d+)"
                component={VisualizarMotivoSituacao}
              />
              <Route
                exact
                path="/motivo-situacao/editar/:id(\d+)"
                component={EditarMotivoSituacao}
              />
              <Route
                exact
                path="/motivo-situacao/alterar-vigencia/:id(\d+)"
                component={AlterarVigenciaMotivoSituacao}
              />

              {/*DOENCA*/}
              <Route
                exact
                path="/doenca/cadastrar"
                component={RegistrarDoenca}
              />
              <Route exact path="/doenca/lista" component={ListaDoenca} />
              <Route
                exact
                path="/doenca/:id(\d+)"
                component={VisualizarDoenca}
              />
              <Route
                exact
                path="/doenca/editar/:id(\d+)"
                component={EditarDoenca}
              />
              <Route
                exact
                path="/doenca/alterar-vigencia/:id(\d+)"
                component={AlterarVigenciaDoenca}
              />

              {/*PERFIL DE ACESSO*/}
              <Route
                exact
                path="/perfil-acesso/cadastrar"
                component={CadastrarPerfilAcesso}
              />
              <Route exact path="/perfil-acesso/lista" component={ListaPerfilAcesso} />
              <Route
                exact
                path="/perfil-acesso/:id(\d+)"
                component={VisualizarPerfilAcesso}
              />
              <Route
                exact
                path="/perfil-acesso/editar/:id(\d+)"
                component={EditarPerfilAcesso}
              />
              <Route
                exact
                path="/perfil-acesso/alterar-vigencia/:id(\d+)"
                component={AlterarVigenciaPerfilAcesso}
              />

              {/*VISITAS*/}
              <Route
                exact
                path="/visitas/cadastrar"
                component={CadastrarVisitas}
              />
              <Route
                exact
                path="/visitas/cadastrar/:id(\d+)"
                component={CadastrarVisitas}
              />
              <Route exact path="/visitas/lista" component={ListaVisitas} />
              <Route
                exact
                path="/visitas/:id(\d+)"
                component={VisualizarVisitas}
              />
              <Route
                exact
                path="/visitas/editar/:id(\d+)"
                component={EditarVisitas}
              />

              {/*DASHBBOARD*/}
              <Route
                exact
                path="/dashboard/servico-acolhimento"
                component={DashboardServicoAcolhimento}
              />
              <Route
                exact
                path="/dashboard/crianca"
                component={DashboardCrianca}
              />
              <Route
                exact
                path="/dashboard/crianca-pendencias"
                component={DashboardCriancaPendencia}
              />
              <Route
                exact
                path="/dashboard/servico-acolhimento-pendencias"
                component={DashboardServicoAcolhimentoPendencia}
              />
              <Route
                exact
                path="/dashboard/avisos"
                component={DashboardAvisos}
              />

              {/*RELATÓRIOS*/}
              <Route
                exact
                path="/relatorios-pendencia/lista"
                component={RelatoriosPendencias}
              />
              <Route
                exact
                path="/relatorios-crianca-adolescente/lista"
                component={
                  roleKeycloack?.includes(
                    dashboardFunc.relatorioCriancaAdolescenteGeral,
                  )
                    ? RelatoriosCriancaAdolescenteGeral
                    : RelatoriosCriancaAdolescente
                }
              />

              <Route
                exact
                path="/relatorios-servico-acolhimento/lista"
                component={RelatoriosServicoAcolhimento}
              />

              {/*FILA DE PROCESSAMENTO*/}
              <Route
                exact
                path="/fila-processamento"
                component={FilaProcessamento}
              />

              {/*AUDITORIA*/}
              <Route exact path="/auditoria" component={Auditoria} />
              <Route
                exact
                path="/auditoria/servico/:id(\d+)"
                component={AuditoriaServico}
              />
              <Route
                exact
                path="/auditoria/crianca/:id(\d+)"
                component={AuditoriaCrianca}
              />

              <Route path={"/404"} exact component={NotFound} />
              <Redirect to={"/404"} />
            </Switch>
          </Layout>
        </MessageContextProvider>
      </PrivateRoute>
    </Flex>
  );
}

export default Routes;
